import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MiamiPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are custom software development services?",
    answer: `<p>Custom software development stands for creating for developing enterprise-grade tools with specific functionalities and UI/UX design or improving an existing application's functionality, usability, and performance.</p>`,
  },
  {
    question: "What technologies do you use for software development?",
    answer: ` <p>Programming languages we use for software development Miami include Java, Kotlin, Swift, Objective, etc., and databases include Firebase, SQLite, CoreData, etc.</p>
        <p>We’re a game app development company; hence, we’re equipped with Unity, Unreal Engine, CryEngine, etc., to develop immersive, engaging games for businesses.</p>`,
  },
  {
    question: "How long does it take to start my software development?",
    answer: `<p>After reviewing your project requirements, we analyze them and then inform you about the estimation results.</p>
        <p>Once we’re on the same page regarding budget and timelines, the next step will be our business analyst creating the project report document and a proposal and sending the same to you for review. After finalization, we’ll proceed to the development stage.</p>`,
  },
  {
    question: "How do you ensure my information privacy and confidentiality?",
    answer: `<p>We’ll sign the NDA and confidentiality agreement with you. Moreover, all our employees are bound by the company’s Confidentiality and Non-Disclosure clauses, which assure clients that their business information and project details are safe with us.</p>`,
  },
  {
    question: "How to Choose a Custom Software Development Company?",
    answer: `<p>Here are the steps to hire a software development Miami company:</p> 
    <ul><li>Define clear project needs.</li>
    <li>Research & shortlist reputable software companies in Miami</li>
    <li>Evaluate their portfolio and client reviews.</li>
    <li>Assess expertise in relevant technologies.</li>
    <li>Ask about their development process and technologies.</li>
    <li>Request a detailed cost of custom software development and timeline</li>
    <li>Verify the company's experience in app security.</li>
    <li>Confirm post-launch support and maintenance options.</li>
    </ul>`,
  },
  {
    question: "How much does it cost to develop custom software?",
    answer: `<p>The cost of custom software development varies based on a number of criteria, including the nature and scale of the software project, as well as the number of developers. However, the average cost to develop custom software is between $25,000 and $300,000.
    Moreover, you can use our cost calculator to get the estimated cost of your project.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{MiamiPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
